import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OnboardingTourStepDataObject } from '../../../models/service/login';

export const getOnboardingSteps = async () =>
  apiClient.get<OnboardingTourStepDataObject[], ApiClientResponse<OnboardingTourStepDataObject[]>>(
    routes.onboardingSteps.find,
  );
